module.exports = __webpack_public_path__ + "img/saddle-figure.2766e76b.svg";